// eslint-disable-next-line no-underscore-dangle
export const _MODULE_NAME = 'auth';
export const KEY_ACCESS_TOKEN = 'accessToken';
export const PROP_IS_LOGGED_IN = 'isLoggedIn';
export const PROP_IS_LOGGING_OUT = 'isLoggingOut';
export const PROP_LOGIN_EXPIRES_SOON = 'loginExpiresSoon';
export const PROP_USER_ACCOUNT_TYPE = 'userAccountType';
export const PROP_USER_ID = 'userId';
export const TOKEN_STORAGE_KEY = 'auth';
export const TOKEN_EXPIRATION_SKIPPABLE_ENDPOINTS = ['/outages'];
